import { TextBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';
import { CardFocusType } from '../../../constants/CardFocusType';

export const Name: React.FC = () => {
    const name = usePaymentStore((s) => s.name);
    const set_name = usePaymentStore((s) => s.set_name);
    const set_cardFocus = usePaymentStore((s) => s.set_cardFocus);

    return (
        <TextBox
            value={name}
            onChange={(value) => set_name(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.Name)}
            label='Name'
            required={true}
        />
    );
};
